import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoaderService} from './loader.service';
import {HEADER_NO_LOADER} from '@myvf/core';
import { Store } from '@ngxs/store';
import { AemState } from '@myvf/aem';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(
    private service: LoaderService,
    private store: Store
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { messages } = this.store.selectSnapshot(AemState);
    let headers: HttpHeaders = req.headers;
    const params: HttpParams = req.params;
    let spinnerText: string;

    if (!headers.has(HEADER_NO_LOADER)&&!req.url.includes('catalog/v1/activable')) {
      if (req.url.includes('checkOCR')) {
        spinnerText = messages?.loadingCheckOCR ?? 'Stiamo verificando i dati inseriti. <br> Ci siamo quasi. Per non perdere l\'avanzamento, non chiudere l\'app.';
      }

      if(!params.has('process_flow_specification')) {
        this.service.show(spinnerText);
      }
    } else {
      headers = headers.delete(HEADER_NO_LOADER);
    }

    const request = req.clone({headers});

    return next
      .handle(request)
      .pipe(
        finalize(() => {
          this.service.hide();
        })
      );

  }
}
